import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import UploadFiles from '@/views/UploadFiles.vue'
import UserManagement from '@/views/UserManagement.vue'
import FileBrowser from '@/views/FileBrowser.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/upload',
    name: 'upload',
    component: UploadFiles,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'users',
    component: UserManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/browse',
    name: 'browse',
    component: FileBrowser,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Guardia de navegación
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.state.auth.isLoggedIn
  const isAdmin = store.state.auth.currentUser?.is_admin
  
  // Redireccionar a Login si se requiere autenticación y el usuario no está logueado
  if (to.meta.requiresAuth && !isLoggedIn) {
    next({ name: 'login' })
  } 
  // Redireccionar al Dashboard si intenta acceder a una ruta solo para administradores y no lo es
  else if (to.meta.requiresAdmin && !isAdmin) {
    next({ name: 'dashboard' })
  }
  // Redireccionar al Dashboard si está logueado e intenta acceder al Login
  else if (isLoggedIn && to.name === 'login') {
    next({ name: 'dashboard' })
  } 
  else {
    next()
  }
})

export default router 